import type { FaceLandmarkerOptions } from '@mediapipe/tasks-vision';
import { MODEL_ASSET_PATH } from './constants';

export function buildConfig(
  runningMode: FaceLandmarkerOptions['runningMode'],
  numFaces: number
): FaceLandmarkerOptions {
  return {
    baseOptions: {
      modelAssetPath: MODEL_ASSET_PATH,
      delegate: 'GPU',
    },
    outputFaceBlendshapes: false,
    outputFacialTransformationMatrixes: true,
    runningMode,
    numFaces,
  };
}
